import { useQuery } from '@apollo/client/react';

import { useAuth } from '@/auth/useAuth';
import { IdentityCard } from '@/components/IdentityCard/IdentityCard';
import { ME_QUERY, type MeQueryResult } from '@/graphql/keystone';

/**
 * The Hello World harness page: prove the two hops the portal is built on —
 * Turnstile said who you are, Keystone agreed when asked with that token.
 */
export function HelloContainer() {
  const { identity } = useAuth();
  const { data, loading, error } = useQuery<MeQueryResult>(ME_QUERY);

  return (
    <IdentityCard
      email={identity?.email ?? null}
      keystonePersonId={data?.me.id}
      loading={loading}
      error={error ? error.message : null}
    />
  );
}
